export default __webpack_public_path__ + "static/media/volcan-villarrica-desdes-isla.23135e32.jpeg";